module.exports = __webpack_public_path__ + "static/media/rectangle-top.12482213.png";